import { Injectable } from '@angular/core';

const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  clean(): void {
    window.localStorage.clear();
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any | undefined {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      const userObj = JSON.parse(user);
      return {...userObj};
    }
  }

  /**
  * last action
  */
  public getLastAction() {
    return window.localStorage.getItem('lastAction') || "";
  }

  /**
   * set last action
   * @param value
   */
  lastAction(value: any) {
    window.localStorage.setItem('lastAction', JSON.stringify(value));
  }

  public isLoggedIn = () => {
    const user = window.localStorage.getItem(USER_KEY);
    console.log('storage loggged call >>',user);
    if (user) {
      return true;
    }

    return false;
  }

  /**
   * Get user preference for landing page layout
   * Returns true for new layout, false for old layout, null if not set (use environment default)
   */
  public getLandingLayoutPreference(): boolean | null {
    const pref = window.localStorage.getItem('landingLayoutPreference');
    if (pref === null) return null;
    return pref === 'new';
  }

  /**
   * Set user preference for landing page layout
   * @param useNewLayout - true for new layout, false for old layout
   */
  public setLandingLayoutPreference(useNewLayout: boolean): void {
    window.localStorage.setItem('landingLayoutPreference', useNewLayout ? 'new' : 'old');
  }

  /**
   * Clear landing layout preference (revert to environment default)
   */
  public clearLandingLayoutPreference(): void {
    window.localStorage.removeItem('landingLayoutPreference');
  }
}
